import { HAR_BASE, HAR_CID } from "../lib/api";
import Seo from "./Seo";

/**
 * Generic HAR.com IDX iframe wrapper.
 * Renders a full-width iframe with a branded header.
 */
export default function HarIdxFrame({ title, eyebrow, description, path, extraParams = "", seoPath = "" }) {
  const src = `${HAR_BASE}/${path}?sitetype=aws&cid=${HAR_CID}${extraParams ? `&${extraParams}` : ""}`;

  return (
    <div className="bg-stone-50 min-h-screen">
      <Seo
        title={title}
        description={description || `${title} — Houston real estate via HAR.com, curated by Gens Realty.`}
        path={seoPath}
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-14 pb-10">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#E63946] mb-3">
          {eyebrow}
        </div>
        <h1 className="font-display text-4xl lg:text-6xl font-light tracking-tighter text-[#1A1A1A] max-w-3xl">
          {title}
        </h1>
        {description && (
          <p className="text-[#555] mt-5 max-w-2xl text-lg">{description}</p>
        )}
      </section>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-20">
        <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
          <iframe
            title={title}
            src={src}
            className="w-full"
            style={{ height: "80vh", minHeight: "720px", border: "0" }}
            data-testid="har-idx-frame"
            loading="lazy"
          />
        </div>
        <div className="mt-3 text-xs text-gray-400 text-center">
          Listings data provided by HAR.com via IDX. Gens Realty, LLC — TREC licensed broker.
        </div>
      </section>
    </div>
  );
}
